export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8533.cf52cec2.jpg";